import { FC, useState } from "react"
import { CategoriasI, HomeI } from "../../models/home"
import Sections from "../Sections"
import SelectImages from "../SelectImages"
import SocialLinks from "../SocialLinks"
import Tiktok from "../Tiktok"
import useHome from "./useHome"
import CustomInputFile from "../Custom/InputFile"
import { handleChangeFile } from "../../utils/files"
import { Backdrop, Button, CircularProgress, Typography } from "@mui/material"
import { updateHomeData } from "../../services/home"
import { urlApi } from "../../utils/strings"
import MultiCategoriasDropzone from "./MultiplesCategorias"
import MultiBannerMediaDropzone from "./Banner/MultiBannerMediaDropzone"

interface Props {
  home: HomeI
}

const Home: FC<Props> = ({ home }) => {

  const {
    onChangeVideoPrincipal, isLoading:isLoadingHome,
    onSubmitForm, setFormData, 
    handleCategoriaFieldChange,
    removeCategoria, formData, isSubmitting
  } = useHome(home)
  const [file, setFile] = useState<File>()
  const [isLoading, setIsLoading] = useState(false)

  const handleClick = async () => {

    if (!file) return alert("Tienes que seleccionar un archivo")

    try {

      setIsLoading(true)

      const formData = new FormData();
      formData.append('image', file);
      formData.append('path', "Secciones/Home"); 
      
      let path = ""
      const url = urlApi(`/images.php`)

      try {
          const response = await fetch(url, {
            method: 'POST',
            body: formData,
          });
    
          const result = await response.json();
          const rute = `${"Secciones/Home"}/${result.filename}`
          console.log(rute)

          path = rute

          if (response.ok) {
            alert('Imagen subida con éxito');
            console.log(result);

          } else {
            alert('Error al subir la imagen');
            console.error(result);
          }
        } catch (error) {
          console.error('Error:', error);
          alert('Error al subir la imagen');
        }

      const data = {
        ...home,
        conocenosLink: path,
        paht_conocenosLink: path,
        
      }

      await updateHomeData(data)

      alert("Agregado correctamente")

    } catch (e) {
      console.error("Error ", e)

    } finally {
      setIsLoading(false)
    }

  }

  return (
    <>
      <Backdrop
        sx={{ 
          color: '#fff', 
          zIndex: (theme) => theme.zIndex.drawer + 1,
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
        open={isSubmitting}
      >
        <CircularProgress size={60} color="inherit" />
        <Typography variant="h6">
          Guardando cambios...
        </Typography>
      </Backdrop>

      <form onSubmit={onSubmitForm} style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
      }}>
        <h1>HOME</h1>


      <div style={{
        background: 'white'
      }} className="contenedor">

        <h2 className="titSeccion">Media</h2>

          <MultiBannerMediaDropzone
              items={formData.medias.sort((a, b) => Number(a.orden) - Number(b.orden))}
              setItems={(items) => {
                setFormData(prev => ({ ...prev, medias: items }));
              }}
              title='Banners (Imágenes y Videos)'
              onRemove={(index) => {
                console.log(index)
                const itemsArray = formData.medias.sort((a, b) => Number(a.orden) - Number(b.orden));
                const filteredItems = itemsArray.filter((_, i) => i !== index);
                setFormData(prev => ({ ...prev, medias: filteredItems }));
              }}
          />
      </div>

      <div style={{
        background: 'white'
      }} className="contenedor">

        <h2 className="titSeccion">Conocenos </h2>
        <CustomInputFile
            label="Imagen - Video"
            onChange={e => {
              setFile(handleChangeFile(e))
            }}
            type='videoimg'
            img={formData.conocenosLink}
        />
         <Button onClick={handleClick}>
          {!isLoading ? 'Guardar' : <CircularProgress />}
        </Button>
      </div>



      <SocialLinks 
        value={formData} 
        onChange={e => {
          setFormData(prev => ({ ...prev, ...e }));
        }} />


      <Sections value={formData.secciones}
        onChange={e => {
          setFormData(prev => ({ ...prev, secciones: e }))
        }} title="Descubre todo lo que tenemos para ti" />


      <SelectImages value={formData.productosDestacados}
        title="Productos destacados" onChange={e => {
          setFormData(prev => ({ ...prev, productosDestacados: e }))
        }} />


      <Tiktok value={formData.tiktok_secciones} onChange={e => {
        setFormData(prev => ({ ...prev, tiktok_secciones: e }))
      }} />

    <h2 className='text-2xl font-bold'>Categorias</h2>
        <MultiCategoriasDropzone
            handleImageFieldChange={handleCategoriaFieldChange}
            categorias={formData.categorias || []}
            setCategorias={(categorias: CategoriasI) =>{

              console.log(categorias)

              setFormData((prev) => ({
                ...prev,
                categorias: categorias,
                }))
              }
            }
            title='Categorias'
            onRemove={removeCategoria}
        />

{isLoadingHome && <div>Cargando Espere...</div>}

      <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', }}>
        <input type="submit" value="Cancelar" className="btnCancelar" disabled={isLoadingHome} />
        <input type="submit" value="Aceptar" className="btnAceptar" disabled={isLoadingHome}/>
      </div>
    </form>
    </>
  )
}

export default Home